var path = 'app/scripts/modules/dcos/job/labels.component.html';
var html = "<div class=\"container-fluid form-horizontal\">\n  <div class=\"form-group\">\n    <h5 class=\"col-sm-12\">\n      Attach metadata to services to expose additional information to other services.\n    </h5>\n    <div class=\"col-sm-12\">\n      <map-editor model=\"$ctrl.labels\" allow-empty=\"true\"></map-editor>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/dcos/job/labels.component.html
// module id = 1727
// module chunks = 0